/* ============================================================
   Epilekton — Toast notifications
   Listens for `cart:added`, `cart:error`, `wishlist:added`
   custom events and renders a transient toast in the
   .epi-toast-stack container. Vanilla JS, deferred, no framework.
   ============================================================ */
(function () {
  'use strict';

  var DEFAULT_DURATION = 3000;

  function getStack() {
    return document.querySelector('.epi-toast-stack');
  }

  function showToast(message, variant) {
    var stack = getStack();
    if (!stack || !message) return;

    var toast = document.createElement('div');
    toast.className = 'epi-toast epi-toast--' + (variant || 'info');
    toast.setAttribute('role', variant === 'error' ? 'alert' : 'status');
    toast.textContent = message;
    toast.addEventListener('click', function () { dismiss(toast); });
    stack.appendChild(toast);

    // Force layout, then reveal
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    });

    var timer = setTimeout(function () { dismiss(toast); }, DEFAULT_DURATION);
    toast.addEventListener('mouseenter', function () { clearTimeout(timer); });
  }

  function dismiss(toast) {
    if (!toast || toast.dataset.dismissing) return;
    toast.dataset.dismissing = '1';
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.remove(); }, 240);
  }

  document.addEventListener('cart:added', function (e) {
    var msg = (e.detail && e.detail.message)
      || (window.epiStrings && window.epiStrings.addedToCart)
      || 'Added to cart';
    showToast(msg, 'success');
  });

  document.addEventListener('cart:error', function (e) {
    var msg = (e.detail && e.detail.message)
      || (window.epiStrings && window.epiStrings.addError)
      || 'Could not add to cart';
    showToast(msg, 'error');
  });

  document.addEventListener('wishlist:added', function (e) {
    var msg = (e.detail && e.detail.message)
      || (window.epiStrings && window.epiStrings.wishlistAdded)
      || 'Saved to favorites';
    showToast(msg, 'success');
  });

  // Public hook so other scripts can fire toasts without dispatching events
  window.epiToast = showToast;
})();
